import { render, staticRenderFns } from "./LoginTpa.vue?vue&type=template&id=6db8f9a9&scoped=true"
import script from "./LoginTpa.vue?vue&type=script&lang=js"
export * from "./LoginTpa.vue?vue&type=script&lang=js"
import style0 from "./LoginTpa.vue?vue&type=style&index=0&id=6db8f9a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db8f9a9",
  null
  
)

export default component.exports